
// SVG Icon: loop
export default { id: "terriajs-loop" };
export const id = "terriajs-loop";
export const name = "loop";
